import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import Agenda1 from '../imagens/Agenda/Agenda1.png';
import Agenda2 from '../imagens/Agenda/Agenda2.png';
import Agenda3 from '../imagens/Agenda/Agenda3.png';
import Agenda4 from '../imagens/Agenda/Agenda4.png';
import Agenda5 from '../imagens/Agenda/Agenda5.png';
import Agenda6 from '../imagens/Agenda/Agenda6.png';
import Agenda7 from '../imagens/Agenda/Agenda7.png';
import Agenda8 from '../imagens/Agenda/Agenda8.png';
import Agenda9 from '../imagens/Agenda/Agenda9.png';
import Agenda10 from '../imagens/Agenda/Agenda10.png';
import Agenda11 from '../imagens/Agenda/Agenda11.png';
import Agenda12 from '../imagens/Agenda/Agenda12.png';
import Agenda13 from '../imagens/Agenda/Agenda13.png';
import Agenda14 from '../imagens/Agenda/Agenda14.png';

export default class Agenda extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como utilizar a agenda"
                className="modal"
                visible={isOpen}
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
            >
                <Row>
                    <Col xs={24}>
                        <p>Para acessar a Agenda:  </p>

                        <div className="image-wrapper">
                            <img className="img_smaller" src={Agenda1} alt="Agenda 1"/>
                        </div>

                        <div className="gray_bar"></div>

                        <h3>Na tela de Agenda nós temos:</h3>

                        <div className="image-wrapper">
                            <img src={Agenda2} alt="Agenda 2"/>
                        </div>

                        <ol>
                            <li>Todos os Status possíveis de um Evento.</li>
                            <li>Botões para navegar entre os dias.</li>
                            <li>Os horários disponíveis.</li>
                            <li>As agendas que estão sendo exibidas.</li>
                            <li>Todos os períodos dispoíveis na agenda e os eventos ja marcados.</li>
                            <li>Filtro de como é definido a agenda, sendo ela por dia/semana/mês/listagem dos eventos.</li>
                            <li>Filtro de quais agendas estão sendo exibidas.</li>
                            <li>Exportação dos eventos cadastrados das agendas.</li>
                        </ol>      

                         <div className="gray_bar"></div>     

                        <h3>Como criar uma nova Agenda</h3>

                        <p>
                            Todos os eventos são separados em Agendas. Para acessar o cadastro de agendas siga o caminho abaixo: 
                        </p>

                        <div className="image-wrapper">
                            <img src={Agenda5} alt="Agenda 5"/>
                        </div>    

                        <p>
                            No cadastro de Agendas, apenas as agendas marcadas como Ativas iram aparecer na tela de Agendas.
                        </p>                      

                        <div className="image-wrapper">
                            <img src={Agenda6} alt="Agenda 6"/>
                        </div> 

  
                        <div className="gray_bar"></div>                                              
                       
                        <h3>Como criar um novo Evento nas Agendas</h3>

                        <p>
                            Para criar um novo evento, basta clicar em um dos horários disponíveis nas agendas e preencher o cadastro de eventos aberto.
                        </p> 
                                              
                        <div className="image-wrapper">
                            <img src={Agenda3} alt="Agenda 3"/>
                        </div>  

                        <div className="image-wrapper">
                            <img src={Agenda4} alt="Agenda 4"/>
                        </div>  

                        <p>
                            Para alterar ou excluir um Evento basta clicar no evento para abrir a tela com as informações do evento. Para alterações apenas 
                            faça as alterações desejadas e clique em salvar. Para excluir basta clicar no botão Excluir.
                        </p>

                        <div className="image-wrapper">
                            <img src={Agenda14} alt="Agenda 14"/>
                        </div>                              

                        <div className="gray_bar"></div>                                        

                        <h3>Gerenciando os eventos</h3>

                        <p>
                            Após criar um evento, você pode clicar e arrastar o registro do evento para mudar o Evento para outra Agenda, ou para outro horário.
                        </p>

                        <div className="image-wrapper">
                            <img src={Agenda7} alt="Agenda 7"/>
                        </div>   

                        <p>
                            É possível támbem aumentar a duração de um evento clicando nas bordas de um evento e arrastando para o horário desejado.
                        </p> 

                        <div className="image-wrapper">
                            <img src={Agenda8} alt="Agenda 8"/>
                        </div>   

                        <p>
                            Você pode também clicar e arrastar para transferir um evento de uma agenda para outra.
                        </p>

                        <div className="image-wrapper">
                            <img src={Agenda10} alt="Agenda 10"/>
                        </div>                         

                        <div className="gray_bar"></div>        

                        <h3>Status</h3>

                        <p>
                            O status atual de um Evento pode ser observado pelas cores que marcam o evento nas Agendas, e a legenda mostra qual o status 
                            dependendo da cor.
                        </p>                  

                        <div className="image-wrapper">
                            <img src={Agenda9} alt="Agenda 9"/>
                        </div>   

                        <div className="gray_bar"></div>  

                        <h3>Filtros</h3>

                        <p>
                            Para navegar pelos dias do calendário o usuário pode utilizar os botões de Anterior e Próximo para navegar pelos dias. Ao clicar no botão Hoje, 
                            a agenda irá voltar para o dia atual.
                        </p>  

                        <div className="image-wrapper">
                            <img src={Agenda11} alt="Agenda 11"/>
                        </div>      

                        <p>
                            Existem também os filtros para exibir as agendas em Dias, Semanas, Meses, ou uma lista com os Eventos cadastrados. 
                        </p>  

                        <div className="image-wrapper">
                            <img src={Agenda12} alt="Agenda 12"/>
                        </div>     

                        <p>
                            Você pode também filtrar quais as Agendas que são exibidas na tela usando o filtro de "Tipos Agendas".
                        </p>  

                        <div className="image-wrapper">
                            <img src={Agenda13} alt="Agenda 13"/>
                        </div>                                                                                                                                                                                                   

                    </Col>
                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/Agenda.js